// extracted by mini-css-extract-plugin
module.exports = {"container":"AccessDenied_container_16rda","header":"AccessDenied_header_3br65","message":"AccessDenied_message_8-ceg","action":"AccessDenied_action_vyhvB"};